import React from 'react';
import config from 'config';
import {BrowserRouter as Router, Route} from 'react-router-dom';
import {Provider} from 'react-redux';
import store from '../store';
import Main from './Main';

const App = () => {
    return (
        <Provider store={store}>
            <Router basename={config.publicPath}>
                <Route><Main /></Route>
            </Router>
        </Provider>
    );
};

export default App;
